import {api} from '../../config';
import {FormInputs} from '../components/pages/register/Form/Form';
import {httpPostJson} from './http';

export type RegisterSuccessResponse = {
  result: 'AUTHENTICATED';
  authTokens: {
    'X-ITKT-TOKEN': string;
    'X-ATKT-TOKEN': string;
  };
};

export type RegisterErrorResponse = {
  result: 'NOT_AUTHENTICATED';
  errors: ('EMAIL_INVALID' | 'TOKEN_MISSING' | 'ACCOUNT_ALREADY_EXISTS')[];
};

export function composeRegister(baseUrl = '') {
  return (body: FormInputs, referralCode?: string | null) =>
    httpPostJson<RegisterSuccessResponse>({
      path: `${baseUrl}${api.mpApiClient}/me`,
      body: {
        ...body,
        cookies: true,
        ...(referralCode ? {referralCode} : {}),
      },
    });
}

export const register = composeRegister();
